import { EActionStatus } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { TRequestTriad } from 'legacy/lut/classes/services/api/OnboardingApi'
import { IWorkFlowStepState } from 'legacy/lut/classes/services/OnboardingStoreService'

export type TActionsState = TRequestTriad & {
  status: EActionStatus
}

export interface IStepConfigs {
  [stepName: string]: TActionsState
}

export const formRegConfig = (config: IWorkFlowStepState[]): IStepConfigs => {
  return config.reduce((acc: IStepConfigs, el) => {
    return {
      ...acc,
      [el.Step]: {
        requestId: el.RequestId,
        actionId: el.ActionId,
        transitionId: el.TransitionId,
        status: el.Status,
      },
    }
  }, {})
}
